import { render, staticRenderFns } from "./second-image.vue?vue&type=template&id=2258b08a&scoped=true&"
import script from "./second-image.vue?vue&type=script&lang=ts&"
export * from "./second-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258b08a",
  null
  
)

export default component.exports